import { render, staticRenderFns } from "./memberPanelSwitch.vue?vue&type=template&id=df6fa88a&scoped=true&"
import script from "./memberPanelSwitch.vue?vue&type=script&lang=js&"
export * from "./memberPanelSwitch.vue?vue&type=script&lang=js&"
import style0 from "./memberPanelSwitch.vue?vue&type=style&index=0&id=df6fa88a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6fa88a",
  null
  
)

export default component.exports